'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function AttachDefaultsNotifier(defaults, notifier) {
    this.defaults = defaults;
    this.notifier = notifier;
}

_base2['default'].extend(AttachDefaultsNotifier, {
    notify: function notify(message) {
        Object.assign(message, this.defaults, message);
        return this.notifier.notify(message);
    },
    push: function push() {
        var _notifier;

        return (_notifier = this.notifier).push.apply(_notifier, arguments);
    }
});

exports['default'] = AttachDefaultsNotifier;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/notifiers/attach-defaults.js
 ** module id = 603
 ** module chunks = 0
 **/